app.service("RoomService", ['$rootScope', function ($rootScope) {

    const modelConstructor = $rootScope.model_constructor;

    const RouteChoice = modelConstructor.RouteChoice;

    const RoomModel = modelConstructor.extend(modelConstructor.RouteModel, {
        name: "Room",
        id: "room",
        navigation_pointer: "room_id",
        choice_order: ['kitchen', 'bedroom'],
        next_model_id: "solution"
    });

    this.factory = new modelConstructor.RouteFactory({
        choices: {
            kitchen: new RouteChoice({
                name: "Kitchens"
            }),
            bedroom: new RouteChoice({
                name: "Bedrooms",
                state_ids: {
                    solution_id: "bedroom_flat_pack",
                    assembly_id: "flat_pack"
                }
            }),
        },
        birth: function (values) {
            return new RoomModel(values);
        }
    })

}]);